import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {handleChangeDrawerState} from 'redux/actions/ThemeActions';

import {IoCloseSharp} from 'react-icons/io5';
import _ from 'lodash';

export default ({open}) => {
    const UserState = useSelector(state => state.User)
    const dispatch = useDispatch()
    const [overWriteStyles, setOverWriteStyles] = useState({
        position: "absolute",
        zIndex: "9999999999",
        left: 14,
        top: "calc(var(--top-navigation-height) + 20px)",
        background: "rgba(0, 0, 0, 0.4)",
        borderRadius: "50%",
        width: 24,
        height: 24,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        opacity: 0,
        transition: "all 0.8s"
    })

    useEffect(() => {
        try {
            if (typeof window !== "undefined") {
                let parameters = {};
                window.location.href.split(/\?(.*)?$/).slice(1).join('').split('&').forEach(function (i) {
                    let t = i.split('=');
                    parameters[t[0]] = t[1];
                });
                let g = document.createElement("script"), s = "https://www.goftino.com/widget/QFPvQd?",
                    l = localStorage.getItem("goftino_QFPvQd");
                if (parameters.userid && parameters.userid.length === 64) {
                    l = parameters.userid;
                    localStorage.setItem("goftino_QFPvQd", l);
                }
                g.async = !0;
                g.src = l ? s + "o=" + l : s;
                if (parameters.op) {
                    g.src += "&assign=" + parameters.op;
                }
                document.getElementsByTagName("head")[0].appendChild(g);

                window.addEventListener('goftino_ready', function () {
                    if (window.innerWidth < 1200) {
                        Goftino.setWidget({icon: false});
                        var gw = document.getElementById("goftino_w");
                        var gf = gw.contentWindow && gw.contentDocument;
                        gf.getElementById("btn-close-chat").style.display = 'none';
                    } else {
                        Goftino.setWidget({icon: true});
                    }
                })

                // goftino_getMessage event (needs handling this is just an example for future use)
                // window.addEventListener("goftino_getMessage", function (d) {
                //     document.getElementById("sender").innerHTML = "Operator";
                //
                //     document.getElementById("type").innerHTML = d.detail.type;
                //
                //     document.getElementById("content").innerHTML = d.detail.content;
                // });
            }
        } catch (e) {
            //
        }
    }, [])

    useEffect(() => {
        try {
            if (!_.isNull(UserState.info)) {
                Goftino.setUser({
                    email: '',
                    name: `${UserState.info.first_name ?? ''} ${UserState.info.last_name ?? ''}`,
                    about: `شناسه کاربر: ${UserState.info.pk + 106879324}`,
                    forceUpdate: true
                });
            }
        } catch (e) {
            // Nothing
        }
    }, [UserState])


    useEffect(() => {
        if (typeof Goftino !== "undefined" && open !== null) {
            if (open) {
                Goftino.open();
                setOverWriteStyles({
                    ...overWriteStyles,
                    opacity: 1
                })
            } else {
                Goftino.close();
                setOverWriteStyles({
                    ...overWriteStyles,
                    opacity: 0
                })
            }
        }
    }, [open])

    return open ?
        <div style={overWriteStyles} onClick={() =>
            dispatch(handleChangeDrawerState({showSupportDrawer: false}))
        }>
            <IoCloseSharp/>
        </div>
        : null
}
